import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';

import { TxKeyword } from '../../../_models';
import { AuthenticationService, NotificationService, EnvService, TxKeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-keyword-detail',
  templateUrl: './keyword-detail.component.html',
  styleUrls: []
})
export class TxKeywordDetailComponent implements OnInit {

  keyword: TxKeyword = null; //Keyword
  countryList: any = [];
  loaded = false;
  loading = true;
  processing = false;
  //env
  intervalList = {};

  constructor(private route: ActivatedRoute,
    private router: Router,
    private envSvc: EnvService,
    private keywordSvc: TxKeywordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.loadDetail(id);
    this.laodIntervalModes();
    this.loadCountryies();
  }


  save() {
    this.processing = true;
    if (confirm("Are you sure to update this keyword?")) {
      this.keywordSvc.updateKeyword(this.keyword).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Keyword updated successfully!", "Update Keyword");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update keyword, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/tx/keyword']);
  }

  private loadDetail(id){
    this.keywordSvc.getKeyword(id).subscribe(data => {
      this.keyword = data
      this.loaded = true;
      this.loading = false;
    });
  }
  private laodIntervalModes(){
    this.envSvc.getIntervalModes().pipe(first()).subscribe(data => {
      this.intervalList = data.data;
    });
  }
  private loadCountryies(){
    this.envSvc.getCountries().pipe(first()).subscribe(data => {
      this.countryList = data.data;
    });
  }
}
